import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import Form from "../form";
export const items = [
    {title: "Rental Start Date", type: "date", required: true},
    {title: "Equipment", name: "rentalFormHashKey", type: "Select", options: [], required: true},
    {title: "Condition of equipment at time of return", example: "New, Fair, Good, Poor", type: "text", required: true}, 
    {title: "Rental Return Date", type: "date", required: true, minV: "Rental Start Date"},
    {title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function ReturnForm({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList, 

    rentalForms
}){
    const [projects, setProjects] = useState([]);
    items[1].options = rentalForms
    .map(rentalForm => ({
        formHashKey: rentalForm.formHashKey, 
        ...JSON.parse(rentalForm.formContent || "{}")
    })).map(rentalForm => ({
        ...rentalForm, 
        projectName: projects.find(project => project.projectHashKey === form.projectHashKey)?.projectName,
        label: <span><strong className = "mr-2">{rentalForm["Equipment Name"]}</strong><span className = "mr-2">{rentalForm["Equipment ID"]}</span><span className = "text-info">{rentalForm["Rental Start Date"]}</span></span>,
        value: rentalForm.formHashKey
    }));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setProjects(resProjectNames.data);
        }
        getData();
        return () => {isMounted = false;}
    },[form.formHashKey, form.foreignKey, setPicData, setSketches]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
        />
    )    
}